import { useCallback } from 'react';
import { Button, Checkbox, Divider, Group, LoadingOverlay, Modal, Typography } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { toast } from '@/components';
import { getQueryClient } from '@/providers';
import { useGetAgreementsActive } from '@/services/agreements';
import {
  useGetUsersCurrent,
  usePutUsersAgreement,
  type UsersAgreementRequest,
} from '@/services/users';

type ChangePasswordProps = {
  opened: boolean;
  onClose?: () => void;
};

const UsersAgreements = ({ opened, onClose }: ChangePasswordProps) => {
  const { mutateAsync, isPending } = usePutUsersAgreement();
  const { data: dataUser } = useGetUsersCurrent();

  const { data: dataAgreements, isPending: loading } = useGetAgreementsActive(
    dataUser?.data?.is_accept_agreement
  );

  const payload = {
    agreement: dataAgreements?.data?.value || '',
    agreement_id: dataAgreements?.data?.id || '',
  } as UsersAgreementRequest;

  const [checked, { toggle }] = useDisclosure(false);

  const onSubmit = useCallback(() => {
    mutateAsync(payload)
      .then(() => {
        toast.success();
        getQueryClient().queryClient.invalidateQueries({
          queryKey: ['users', 'current'],
        });
      })
      .catch((e) => {
        toast.error({
          title: 'Gagal',
          message: e?.response?.data?.message,
        });
      });
  }, [payload]);

  return (
    <Modal
      withCloseButton={false}
      size={800}
      opened={opened}
      onClose={() => onClose?.()}
      centered
      title="Syarat & Ketentuan"
    >
      <LoadingOverlay visible={loading} />
      <Typography>
        <div dangerouslySetInnerHTML={{ __html: dataAgreements?.data?.value || '' }} />
      </Typography>
      <Divider my={16} />
      <Group align="center">
        <Checkbox label="Setuju" onChange={toggle} checked={checked} />
        <Button ml="auto" disabled={!checked} loading={isPending} onClick={() => onSubmit()}>
          Submit
        </Button>
      </Group>
    </Modal>
  );
};

export default UsersAgreements;
